"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const HelpWorkRegistrationCard_1 = __importDefault(require("@Components/HelpWorkRegistrationCard"));
const Button_1 = require("@Components/Buttons/Button");
const pathes_1 = __importDefault(require("@App/dicts/pathes"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const BulkUploadErrorPopup_1 = __importDefault(require("@Components/Popups/BulkUploadErrorPopup"));
const bulk_upload_error_type_1 = require("@App/enum/bulk-upload-error-type");
const FileUploadStep = () => {
    const { bulkUploadStore, popupStore, workStore, uiStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const checkValidationFileType = (fileName) => {
        const arrayName = fileName.split('.');
        const type = arrayName[arrayName.length - 1].toLowerCase();
        return type === 'xlsx' || type === 'csv';
    };
    const onClosePopup = () => {
        try {
            bulkUploadStore.setInfoModalForBulkUpload(null);
        }
        catch (error) {
            popupStore.setAlertFromError(error);
        }
    };
    const onLoadFile = (files) => {
        if (!files || !files[0]) {
            return;
        }
        // clear old works
        bulkUploadStore.destroyAllWorksFromUpload();
        bulkUploadStore.destroyWorksOnCurrentPage();
        const isFileValid = checkValidationFileType(files[0].name);
        if (!isFileValid) {
            return;
        }
        bulkUploadStore.setWorkFileDraftToLocal(files[0]);
    };
    const loadTemplateFile = () => {
        window.location.href = pathes_1.default.Upload.downloadTemplate;
    };
    (0, react_1.useEffect)(() => () => workStore.setWizardStepValidation(false), []);
    const modalErrorType = bulkUploadStore.modalErrorType;
    const modalErrorMessage = bulkUploadStore.modalErrorMessage;
    const openModal = modalErrorType !== undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "file-upload-step" },
            react_1.default.createElement("div", { className: "file-upload-wrapper" },
                react_1.default.createElement("div", { className: "upload-area" },
                    react_1.default.createElement("p", { className: 'small' }, "Please select the file you want to upload."),
                    react_1.default.createElement("div", { className: "file-area" },
                        bulkUploadStore.workFileDraftLocal ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", null, bulkUploadStore.workFileDraftLocal
                                ? bulkUploadStore.workFileDraftLocal.name
                                    ? bulkUploadStore.workFileDraftLocal.name
                                    : 'MLCBulkWork_V1.2.xlsx'
                                : ''),
                            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary-small', onClick: bulkUploadStore.destroyWorkFileDraftLocal }, "Remove"))) : null,
                        react_1.default.createElement("input", { formEncType: 'multipart/form-data', type: 'file', id: 'upload', name: 'file', accept: '.xlsx,.csv', onChange: (e) => {
                                onLoadFile(e.target.files);
                            } })),
                    react_1.default.createElement("div", { className: "label-button-wrapper" },
                        react_1.default.createElement("label", { htmlFor: "upload", className: '' }, "Browse Files")),
                    react_1.default.createElement("p", { className: "small" },
                        react_1.default.createElement("span", { className: "bold-note" }, "Please note:"),
                        " Publishing information should only be entered for shares you control. Please do not enter publishing and shares information for publishers you do not represent.")),
                react_1.default.createElement("div", { className: "publishers-help-area" },
                    react_1.default.createElement(HelpWorkRegistrationCard_1.default, null,
                        react_1.default.createElement("h5", { className: "title" }, "How do I format the file?"),
                        react_1.default.createElement("p", { className: "info" }, "To create a Bulk Work Registration file, first download the template provided below. Once opened, fill out each column with as much information as you have. Definitions for each column can be found under the Field Definitions tab."),
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", { className: "info" }, "Required columns: Noted with an asterisk ( * )."),
                            react_1.default.createElement("li", { className: "info" },
                                "Dependent fields: These fields are not required, but if you enter information in one column, you must enter information in the other. These columns are:",
                                react_1.default.createElement("ul", { className: "sub-list" },
                                    react_1.default.createElement("li", { className: "info" }, "Administrator Name and Administration IPI"),
                                    react_1.default.createElement("li", { className: "info" }, "Recording Title and Recording Artist Name"),
                                    react_1.default.createElement("li", { className: "info" }, "AKA Title and AKA Type Code"))),
                            react_1.default.createElement("li", { className: "info" }, "Size: There is a maximum of 300 rows for upload. If your document requires more rows, you will need to create another document for upload."),
                            react_1.default.createElement("li", { className: "info" }, "Upload format: The file must save as a .xlsx format to upload.")),
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: loadTemplateFile }, "Download template"),
                        react_1.default.createElement("p", { className: "version info" }, "Current version: v1.2"))))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: openModal, onClose: onClosePopup },
            react_1.default.createElement(BulkUploadErrorPopup_1.default, { modalErrorType: modalErrorType !== null && modalErrorType !== void 0 ? modalErrorType : bulk_upload_error_type_1.BulkUploadErrorType.UNKNOWN, modalErrorMessage: modalErrorMessage, onClose: onClosePopup })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: uiStore.isMobile, onClose: onClosePopup },
            react_1.default.createElement(Popup_1.default, { showClose: false, onClose: onClosePopup },
                react_1.default.createElement("div", { className: 'info-head' },
                    react_1.default.createElement("p", { className: "bold" }, "Bulk works registration is not available while on a mobile device. Please revisit the page from a non-mobile device to continue with your bulk work registration. Click the back button to return to the catalog page.")),
                react_1.default.createElement("div", { className: "search-confirm-popup-content" },
                    react_1.default.createElement("div", { className: 'buttons-block' },
                        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', typeLink: true, linkTo: navigation_1.default.rightholder.catalog.root(rightsholderStore.currentRightsholderId), onClick: onClosePopup }, "Back")))))));
};
exports.default = (0, mobx_react_1.observer)(FileUploadStep);
